/**
 * @param {any} argument 
 * @param {String} argumentName 
 */
export function throwIfNull(argument, argumentName) {
    if (argument == undefined || argument == null)
        throw new Error(`Argument ${argumentName} cannot be null`)
}

/**
 * @param {Number} argument 
 * @param {String} argumentName 
 */
export function throwIfNullOrZeroOrNegative(argument, argumentName) {
    if (argument == undefined || argument == null || argument <= 0)
        throw new Error(`Argument ${argumentName} cannot be null, zero or negative: ${argument}`)
}

export { ArgumentNullError } from './ArgumentNullError'
export { ClassMemberNullError } from './ClassMemberNullError'
